import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const HASHVALUE = () => {
  return (
    <CardSection id="HASHVALUE" title="HASHVALUE">
      <Paragraph>
        Fuzzy 매칭을 더 쉽게 하기 위해 텍스트 문자열을 변환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>HASHVALUE(STRING, OPTION, [VALUE])</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 변환하려는 문자열입니다.
          </Li>
          <Li>
            <b>OPTION</b>은 변환에 사용할 알고리즘입니다. 사용 가능한 옵션은
            다음과 같습니다.
            <Ul>
              <Li>METAPHONE</Li>
              <Li>NGRAM</Li>
              <Li>FINGERPRINT</Li>
            </Ul>
          </Li>
          <Li>
            <b>VALUE</b>는 사용할 ngram의 수를 지정합니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열, 텍스트 문자열을 포함하는 열
          또는 텍스트 문자열을 반환하는 함수여야 합니다. <b>OPTION</b>과{" "}
          <b>VALUE</b>는 모두 문자열로 처리 되며 따옴표로 묶어야 합니다 (예:{" "}
          <Paragraph accent>"metaphone"</Paragraph>)
        </Paragraph>
        <Paragraph>
          <b>HASHVALUE</b>는 제공된 문자열 값을 기반으로 해시를 생성하는
          알고리즘을 사용합니다. 사용된 알고리즘은 <b>Cluster + Edit</b> 열
          작업에서도 열 내의 값 간의 근접 일치 항목을 찾는 데 사용됩니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
